// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.similar-panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.similar-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px 0;
}

.similar-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #000;
}

.btn-reset-similar {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #999;
  padding: 0 4px;
  line-height: 1;
}

.btn-reset-similar:hover {
  color: #333;
}

.similar-page-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px 10px;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 13px;
}

.similar-page-selector span {
  color: #666;
}

.similar-page-selector select {
  flex: 1 1;
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  background: #fff;
  cursor: pointer;
}

.similar-page-selector select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.similar-stage-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.btn-stage {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s ease;
  color: white;
}

.btn-stage-1 { background: #1976d2; }
.btn-stage-2 { background: #7b1fa2; }
.btn-stage-3 { background: #e65100; }

.btn-stage:hover:not(:disabled) { opacity: 0.9; }
.btn-stage:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-right: 6px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.similar-stage-hint {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.similar-loading {
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 14px;
}

.similar-empty {
  text-align: center;
  padding: 20px 0;
}

.similar-empty p {
  color: #666;
  font-size: 14px;
  margin-bottom: 16px;
}

.btn-calculate {
  background: var(--button-color);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: 100%;
}

.btn-calculate:hover:not(:disabled) {
  opacity: 0.9;
}

.btn-calculate:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.similar-header-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.similar-count {
  font-size: 13px;
  color: #666;
}

.btn-recalculate {
  background: transparent;
  border: 1px solid #e0e0e0;
  color: #666;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-recalculate:hover:not(:disabled) {
  border-color: var(--button-color);
  color: var(--button-color);
}

.btn-recalculate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.similar-timestamp {
  font-size: 11px;
  color: #999;
  margin-bottom: 12px;
}

.similar-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.similar-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.similar-group-title {
  font-weight: 600;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 4px;
  margin-bottom: 4px;
}

.similar-group-title.very-similar {
  color: #2e7d32;
  background: #e8f5e9;
  border-left: 3px solid #2e7d32;
}

.similar-group-title.related {
  color: #666;
  background: #f5f5f5;
  border-left: 3px solid #999;
}

.similar-group-title.rejected {
  color: #b71c1c;
  background: #fdecea;
  border-left: 3px solid #b71c1c;
}

.similar-item {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  transition: border-color 0.2s ease;
}

.similar-item:hover {
  border-color: #ccc;
}

.similar-item-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  cursor: pointer;
  background: #fafafa;
  transition: background 0.2s ease;
}

.similar-item-header:hover {
  background: #f5f5f5;
}

.similar-item-header.expanded {
  background: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
}

.similar-item-info {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.similar-rank {
  font-size: 11px;
  color: #999;
  font-weight: 600;
}

.similar-score {
  background: var(--button-color);
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
}

.similar-filename {
  flex: 1 1;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.similar-expand-icon {
  font-size: 10px;
  color: #999;
  flex-shrink: 0;
}

.similar-item-content {
  padding: 12px;
  background: #fff;
}

.similar-thumbnail {
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
  background: #f5f5f5;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.similar-thumbnail:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.similar-thumbnail img {
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: contain;
  display: block;
}

.similar-thumbnail-loading {
  padding: 30px;
  text-align: center;
  background: #f5f5f5;
  border-radius: 4px;
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
}

.similar-thumbnail-error {
  padding: 30px;
  text-align: center;
  background: #fff5f5;
  border: 1px dashed #ffccc7;
  border-radius: 4px;
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
}

.btn-view-analysis {
  width: 100%;
  background: transparent;
  color: var(--button-color);
  border: 1px solid var(--button-color);
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-view-analysis:hover {
  background: var(--button-color);
  color: white;
}

.similar-no-results {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 13px;
}

/* Modal for enlarged image */
.similar-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.similar-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  animation: zoomIn 0.2s ease;
}

@keyframes zoomIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.similar-modal-content img {
  max-width: 100%;
  max-height: 85vh;
  width: auto;
  height: auto;
  display: block;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.similar-modal-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  padding: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
}

.similar-modal-close:hover {
  background: #fff;
}

/* Heuristic search */
.similar-heuristic {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;
}

.heuristic-status {
  color: #555;
  font-weight: 500;
  font-size: 13px;
}

.similar-group-title.heuristic {
  color: #666;
  background: #f5f5f5;
  border-left: 3px solid #999;
}

/* Responsive */
@media (max-width: 1200px) {
  .similar-panel {
    max-height: none;
  }
}

/* LAKPED-14 — la referencia de la pieza, debajo del nombre del archivo */
.similar-item-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
}

/* la referencia sin historial es un dato de apoyo: no debe pesar más que el nombre del archivo */
.similar-item-main .reference-history-plana {
  font-size: 11px;
  color: #8a94a0;
  letter-spacing: 0.2px;
}

.similar-item-main .similar-filename { flex: none; max-width: 100%; }

/* el chip abre su propio desplegable: el clic no debe plegar la tarjeta */
.similar-item-reference { cursor: default; max-width: 100%; }

/* que una tarjeta con el historial abierto no encoja a las de al lado */
.similar-item { flex-shrink: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/History/SimilarDrawingsPanel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA,eAAe,mBAAmB,EAAE;AACpC,eAAe,mBAAmB,EAAE;AACpC,eAAe,mBAAmB,EAAE;;AAEpC,kCAAkC,YAAY,EAAE;AAChD,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,yEAAyE;AACzE;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,iGAAiG;AACjG;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA,uCAAuC,UAAU,EAAE,eAAe,EAAE;;AAEpE,0EAA0E;AAC1E,0BAA0B,eAAe,EAAE,eAAe,EAAE;;AAE5D,wEAAwE;AACxE,gBAAgB,cAAc,EAAE","sourcesContent":[".similar-panel {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.similar-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 16px 0;\n}\n\n.similar-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  color: #000;\n}\n\n.btn-reset-similar {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #999;\n  padding: 0 4px;\n  line-height: 1;\n}\n\n.btn-reset-similar:hover {\n  color: #333;\n}\n\n.similar-page-selector {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 8px 10px;\n  background: #f5f5f5;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.similar-page-selector span {\n  color: #666;\n}\n\n.similar-page-selector select {\n  flex: 1;\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.similar-page-selector select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.similar-stage-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.btn-stage {\n  flex: 1;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  color: white;\n}\n\n.btn-stage-1 { background: #1976d2; }\n.btn-stage-2 { background: #7b1fa2; }\n.btn-stage-3 { background: #e65100; }\n\n.btn-stage:hover:not(:disabled) { opacity: 0.9; }\n.btn-stage:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.btn-spinner {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(255,255,255,0.4);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  vertical-align: middle;\n  margin-right: 6px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.similar-stage-hint {\n  font-size: 12px;\n  color: #666;\n  white-space: nowrap;\n}\n\n.similar-loading {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n  font-size: 14px;\n}\n\n.similar-empty {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.similar-empty p {\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.btn-calculate {\n  background: var(--button-color);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  width: 100%;\n}\n\n.btn-calculate:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.btn-calculate:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.similar-header-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.similar-count {\n  font-size: 13px;\n  color: #666;\n}\n\n.btn-recalculate {\n  background: transparent;\n  border: 1px solid #e0e0e0;\n  color: #666;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btn-recalculate:hover:not(:disabled) {\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\n.btn-recalculate:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.similar-timestamp {\n  font-size: 11px;\n  color: #999;\n  margin-bottom: 12px;\n}\n\n.similar-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.similar-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.similar-group-title {\n  font-weight: 600;\n  font-size: 12px;\n  padding: 6px 10px;\n  border-radius: 4px;\n  margin-bottom: 4px;\n}\n\n.similar-group-title.very-similar {\n  color: #2e7d32;\n  background: #e8f5e9;\n  border-left: 3px solid #2e7d32;\n}\n\n.similar-group-title.related {\n  color: #666;\n  background: #f5f5f5;\n  border-left: 3px solid #999;\n}\n\n.similar-group-title.rejected {\n  color: #b71c1c;\n  background: #fdecea;\n  border-left: 3px solid #b71c1c;\n}\n\n.similar-item {\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: border-color 0.2s ease;\n}\n\n.similar-item:hover {\n  border-color: #ccc;\n}\n\n.similar-item-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n  background: #fafafa;\n  transition: background 0.2s ease;\n}\n\n.similar-item-header:hover {\n  background: #f5f5f5;\n}\n\n.similar-item-header.expanded {\n  background: #f0f0f0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.similar-item-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.similar-rank {\n  font-size: 11px;\n  color: #999;\n  font-weight: 600;\n}\n\n.similar-score {\n  background: var(--button-color);\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 10px;\n}\n\n.similar-filename {\n  flex: 1;\n  font-size: 13px;\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.similar-expand-icon {\n  font-size: 10px;\n  color: #999;\n  flex-shrink: 0;\n}\n\n.similar-item-content {\n  padding: 12px;\n  background: #fff;\n}\n\n.similar-thumbnail {\n  cursor: pointer;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 10px;\n  background: #f5f5f5;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.similar-thumbnail:hover {\n  transform: scale(1.02);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.similar-thumbnail img {\n  width: 100%;\n  height: auto;\n  max-height: 150px;\n  object-fit: contain;\n  display: block;\n}\n\n.similar-thumbnail-loading {\n  padding: 30px;\n  text-align: center;\n  background: #f5f5f5;\n  border-radius: 4px;\n  color: #999;\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n\n.similar-thumbnail-error {\n  padding: 30px;\n  text-align: center;\n  background: #fff5f5;\n  border: 1px dashed #ffccc7;\n  border-radius: 4px;\n  color: #999;\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n\n.btn-view-analysis {\n  width: 100%;\n  background: transparent;\n  color: var(--button-color);\n  border: 1px solid var(--button-color);\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-view-analysis:hover {\n  background: var(--button-color);\n  color: white;\n}\n\n.similar-no-results {\n  text-align: center;\n  padding: 20px;\n  color: #999;\n  font-size: 13px;\n}\n\n/* Modal for enlarged image */\n.similar-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(8px);\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.similar-modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  animation: zoomIn 0.2s ease;\n}\n\n@keyframes zoomIn {\n  from { transform: scale(0.9); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n.similar-modal-content img {\n  max-width: 100%;\n  max-height: 85vh;\n  width: auto;\n  height: auto;\n  display: block;\n  border-radius: 8px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.similar-modal-close {\n  position: absolute;\n  top: -40px;\n  right: 0;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #000;\n  padding: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s ease;\n}\n\n.similar-modal-close:hover {\n  background: #fff;\n}\n\n/* Heuristic search */\n.similar-heuristic {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.heuristic-status {\n  color: #555;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.similar-group-title.heuristic {\n  color: #666;\n  background: #f5f5f5;\n  border-left: 3px solid #999;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .similar-panel {\n    max-height: none;\n  }\n}\n\n/* LAKPED-14 — la referencia de la pieza, debajo del nombre del archivo */\n.similar-item-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 3px;\n}\n\n/* la referencia sin historial es un dato de apoyo: no debe pesar más que el nombre del archivo */\n.similar-item-main .reference-history-plana {\n  font-size: 11px;\n  color: #8a94a0;\n  letter-spacing: 0.2px;\n}\n\n.similar-item-main .similar-filename { flex: none; max-width: 100%; }\n\n/* el chip abre su propio desplegable: el clic no debe plegar la tarjeta */\n.similar-item-reference { cursor: default; max-width: 100%; }\n\n/* que una tarjeta con el historial abierto no encoja a las de al lado */\n.similar-item { flex-shrink: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
